import { MapIcon, Phone } from '@repo/ui/components/icon';

export interface MenuItem {
  href: string;
  title: string;
  child?: MenuItem[];
}

interface IFooterNavLink {
  href: string
  icon: any
  title: string
}
export const menu_header:{
  title: any,
  href:string
}[] = [
  { href: "/", title: "header.menu.home" },
  {
    href: "/ky-gui",
    title: "header.menu.deposit",
  },
  {
    href: "/mua-ban-mua-ban-can-ho",
    title: "header.menu.products",
  },
  {
    href: "/du-an",
    title: "header.menu.projects",
  },
  { href: "/tin-tuc", title: "header.menu.news" },
    { href: "/cong-tac-vien", title: "header.menu.collaborator" },
  {
    href: "/tuyen-dung",
    title: "header.menu.recruitment",
  },
  { href: "/gioi-thieu", title: "header.menu.about" },
  { href: "/lien-he", title: "header.menu.contact" },
];

export const footerNavLink: IFooterNavLink[] = [
  { href: '', icon: MapIcon, title: 'Tòa nhà văn phòng Star Tower Tầng 5 số 68 Dương Đình Nghệ, Cầu Giấy, Hà Nội' },
  { href: 'tel:02463272727', icon: Phone, title: '02463.27.27.27',  },
]

export const menu_footer =[
  [
    {
      href: "/gioi-thieu",
      title:'Giới thiệu'
    },
    {
      href: "/tim-nha",
      title: 'Tìm nhà'
    },
    {
      href: "/ki-gui-nha",
      title: 'Kí gửi nhà'
    }
  ],
  [
    {
      href: "/tuyen-dung",
      title: 'Tuyển dụng'
    },
    {
      href: "/tin-tuc",
      title: 'Tin tức'
    },
    {
      href: "/lien-he",
      title: 'Liên hệ'
    }
  ],
]
